import createDisplayEnum, { EnumDisplayLabels } from 'utils/createDisplayEnum';

enum StocktakeTargetType {
    Inventory = 'INVENTORY',
    InventoryGroup = 'INVENTORYGROUP',
    Location = 'LOCATION',
}
export default StocktakeTargetType;

const labels: EnumDisplayLabels<typeof StocktakeTargetType> = {
    Inventory: 'Inventory',
    InventoryGroup: 'Inventory group',
    Location: 'Location',
};

export const StocktakeTargetTypeDisplay = createDisplayEnum(StocktakeTargetType, labels);
